// removed by extract-text-webpack-plugin
module.exports = {"currentMenuWrapper":"current-menu-wrapper--2w4My","tutorialHeading":"tutorial-heading--243nb"};


//////////////////
// WEBPACK FOOTER
// ./app/components/containers/ticketing/categorySettings/categorySettings.scss
// module id = 1gYW
// module chunks = 1